import { render, staticRenderFns } from "./DialogCancelarCobranca.vue?vue&type=template&id=0d590865&"
import script from "./DialogCancelarCobranca.vue?vue&type=script&lang=js&"
export * from "./DialogCancelarCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports